import { Breakpoints } from '@angular/cdk/layout';

/**
 * Mapeo estándar de breakpoints de Angular CDK
 * Utilizamos la estandarización oficial de Angular para consistencia
 */
export const STANDARD_BREAKPOINTS = {
  mobile: Breakpoints.XSmall, // (max-width: 599.98px)
  tablet: Breakpoints.Small, // (min-width: 600px) and (max-width: 959.98px)
  desktop: Breakpoints.Medium, // (min-width: 960px) and (max-width: 1279.98px)
  large: Breakpoints.Large, // (min-width: 1280px) and (max-width: 1919.98px)
  xlarge: Breakpoints.XLarge, // (min-width: 1920px)
} as const;

/**
 * Breakpoints específicos para dispositivos con orientación
 * Útiles para casos específicos donde la orientación importa
 */
export const DEVICE_BREAKPOINTS = {
  handsetPortrait: Breakpoints.HandsetPortrait, // (max-width: 599.98px) and (orientation: portrait)
  handsetLandscape: Breakpoints.HandsetLandscape, // (max-width: 959.98px) and (orientation: landscape)
  tabletPortrait: Breakpoints.TabletPortrait, // (min-width: 600px) and (max-width: 839.98px) and (orientation: portrait)
  tabletLandscape: Breakpoints.TabletLandscape, // (min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape)
  webPortrait: Breakpoints.WebPortrait, // (min-width: 840px) and (orientation: portrait)
  webLandscape: Breakpoints.WebLandscape, // (min-width: 1280px) and (orientation: landscape)
} as const;
